export const initialListArray = ['Motorcycle', 'Bus', 'Car'];

export const initialListValue = [
  { id: 1, value: 'Motorcycle' },
  { id: 2, value: 'Bus' },
  { id: 3, value: 'Car' },
];
